import React from 'react';

const ArrowIcon = () => (
  <div className="ws-ui-cta-text__arrow-icon">
    <svg width="19" height="30" viewBox="0 0 19 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0488 29.5719C18.4068 29.5449 18.6751 29.2329 18.6482 28.8749C18.6212 28.5169 18.3091 28.2486 17.9512 28.2756L18.0488 29.5719ZM6.62674 0.695385C6.4585 0.378262 6.06504 0.257562 5.74792 0.425796L0.580083 3.16733C0.262959 3.33556 0.14226 3.72902 0.310494 4.04615C0.478728 4.36327 0.872188 4.48397 1.18931 4.31573L5.78294 1.87882L8.21986 6.47245C8.38809 6.78957 8.78155 6.91027 9.09868 6.74204C9.4158 6.5738 9.5365 6.18034 9.36827 5.86322L6.62674 0.695385ZM17.9512 28.2756C8.81885 28.9636 4.25851 24.7356 3.30303 22.2611L2.09029 22.7293C3.3071 25.8807 8.51279 30.2903 18.0488 29.5719L17.9512 28.2756ZM3.30303 22.2611C2.79763 20.9522 2.43739 19.6412 2.7924 16.7043C3.15296 13.7215 4.24821 9.09815 6.67395 1.19063L5.43111 0.809372C3.003 8.72465 1.87724 13.4424 1.50179 16.5483C1.1208 19.7001 1.50954 21.2253 2.09029 22.7293L3.30303 22.2611Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export default ArrowIcon;
